const { Core, Events } = Global;

customElements.define('main-nav-mobile-loader', class extends Core {
    elements = {
        $: [['level']]
    }

    render() {
        customElements.whenDefined('main-nav-mobile').then(() => {
            const levels = this.$('level').map(level => ({
                level: +level.dataset.level,
                children: Array.from(level.childNodes)
            }));

            this.pub(Events.HEADER_UPDATE, levels);
            this.remove();
        });
    }
});
